import * as React from "react";
import { Grid, Icon, Menu, Pagination,Input } from "semantic-ui-react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Link } from "..";

export interface ITableFooter {
  onClickCSV?: () => void;
  currentPage?: number;
  totalPages?: number;
  total?: number;
  perPage?: number;
  onSelectedPage?: (pageNo: number) => void;
}

class TableFooter extends React.Component<ITableFooter> {
  public render() {
    const { currentPage, totalPages, onSelectedPage,total,perPage } = this.props;
    return (
      <Grid columns={2} verticalAlign="middle">
        <Grid.Row>
        <Grid.Column floated="left" computer={3} tablet={16}>
            { total?`ทั้งหมด ${total} รายการ`:null } 
          </Grid.Column>
          {/* <Grid.Column mobile={16} tablet={6} computer={6} floated="left"> */}
            {/* <Link
              shade={3}
              size="large"
              hideUnderline
              onClick={this.onClickCSV}
            >
              Download as CSV
            </Link> */}
          {/* </Grid.Column> */}
          <Grid.Column mobile={16} tablet={10} computer={10} floated="right">
            <Pagination
              size="mini"
              floated="right"
              activePage={totalPages! > 0 ? currentPage : 0}
              totalPages={totalPages || 0}
              onPageChange={(e: any, { activePage }: any) => onSelectedPage!(activePage)}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  private onClickCSV = () => {
    const { onClickCSV } = this.props;
    if (typeof onClickCSV !== "undefined") {
      onClickCSV();
    }
  };
}

const style = {
  input: {
    width: "100px",
    padding: "0 5px"
  }
};
export default TableFooter;
